import { useMutation } from "@tanstack/react-query";
import {
  createTableBooking,
  CreateBookingInput,
} from "../utils/bookingService";

/**
 * Custom hook for table booking mutation
 *
 * Usage:
 * const { mutate, isPending, isError, error } = useTableBooking();
 *
 * mutate({ restaurantId, restaurantName, numberOfPeople, bookingDate, bookingTime });
 */
export const useTableBooking = () => {
  return useMutation({
    mutationFn: (bookingData: CreateBookingInput) =>
      createTableBooking(bookingData),
  });
};
